import { RecurringTypesEnum } from "dash-common";
import { ViewerContext } from "dash-ui";
import { useContext, useState } from "react";

// This hook sets initial recurring type according to current subscription
export function useRecurringType() {
  const { subscription } = useContext(ViewerContext);

  const initialRecurringType =
    subscription?.subscriptionProduct?.recurringType === RecurringTypesEnum.FREE
      ? RecurringTypesEnum.MONTH
      : subscription?.subscriptionProduct?.recurringType ||
        RecurringTypesEnum.MONTH;

  const [recurringType, setRecurringType] =
    useState<RecurringTypesEnum>(initialRecurringType);

    return { recurringType, setRecurringType }
}